<script>
import _ from 'lodash'
import { captionsExceptBy } from '../../Presentaciones/archetype'
import { archetype, automodalHandler } from './archetype'
import PresentacionesIndex from '../../Presentaciones/PresentacionesIndex.vue'
import PresentacionQuicktable from '../../Presentaciones/quicktable.vue'

export default {
    name: 'conceptIngredientesAutomodal',
    components: {PresentacionesIndex, PresentacionQuicktable},
    props: {
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
                claves: {
                    divisiones: [],
                    grupos: [],
                    clases: [],
                    claves: [],

                    // FILTERED VERSIONS, NOT COMPUTED FOR PERFORMANCE
                    grupos_f: [],
                    clases_f: [],
                    claves_f: []
                },
                categorias: [],
                nutricionales: []
            },
        }
    },
    computed: {
        nutricionalesCat() {
            let cats = [];
            _.forEach(this.asides.nutricionales, (nutr) => {
                cats.push(nutr.categoria)
            })
            return _.uniq(cats)
        },
        cArchetype() {
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(itemsRow);
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    if (item.key == 'id_padre_fk') {
                        item.options = this.asides.categorias
                    }
                    else if (item.key == 'clave_clase_division') {
                        item.options = this.asides.claves.divisiones
                    }
                    else if (item.key == 'clave_clase_grupo') {
                        item.options = this.asides.claves.grupos_f
                    }
                    else if (item.key == 'clave_clase_clase') {
                        item.options = this.asides.claves.clases_f
                    }
                    else if (item.key == 'clave_clase_pk') {
                        item.options = this.asides.claves.claves_f
                    }
                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        captionsExceptBy,
        updateFormFromNutri() {
            let cp = _.cloneDeep(this.form)
            cp.nutricionales = _.cloneDeep(this.asides.nutricionales)
            this.$refs.automodal.set(cp)
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                this.asides.claves.divisiones = asides.claves.divisiones
                this.asides.claves.grupos = asides.claves.grupos
                this.asides.claves.clases = asides.claves.clases
                this.asides.claves.claves = asides.claves.claves
                this.asides.categorias = asides.categorias
                this.asides.nutricionales = []
                _.forEach(asides.nutricionales, nut => {
                    this.asides.nutricionales.push(nut)
                })
            }
        },
        reloadClaves() {
            let clave = _.find(this.asides.claves.claves, { value: this.form.clave_clase_pk }),
                clase, grupo, division;
            if (!!clave) {
                clase = _.find(this.asides.claves.clases, { value: clave.clase_id })
                grupo = _.find(this.asides.claves.grupos, { value: clase.grupo_id })
                // division = _.find(this.asides.claves.divisiones, {value: grupo.division_id})
                this.form.clave_clase_division = grupo.division_id
                this.form.clave_clase_grupo = clase.grupo_id
                this.form.clave_clase_clase = clase.value
                this.$refs.automodal.set(this.form)
            }
            console.log("clave", clave, clase, grupo, division)
        },
        checkClaves() {
            let cp = _.cloneDeep(this.form);
            (() => {
                let filtering = { division_id: cp.clave_clase_division + '' }
                this.asides.claves.grupos_f = _.filter(this.asides.claves.grupos, filtering)
                if (!this.asides.claves.grupos_f.length) {
                    cp.clave_clase_grupo = null
                }
            })();
            (() => {
                let filtering = { grupo_id: cp.clave_clase_grupo + '' }
                this.asides.claves.clases_f = _.filter(this.asides.claves.clases, filtering)
                if (!this.asides.claves.clases_f.length) {
                    cp.clave_clase_clase = null
                }
            })();
            (() => {
                let filtering = { clase_id: cp.clave_clase_clase + '' }
                this.asides.claves.claves_f = _.filter(this.asides.claves.claves, filtering)

                if (!this.asides.claves.claves_f.length) {
                    cp.clave_clase_pk = null
                }
            })();
            if (JSON.stringify(cp) != JSON.stringify(this.form)) {
                // alert('asf')
                this.$refs.automodal.set(cp)
            }
        },
        getNutricionalsIndex(categoria) {
            let indx = [],
                filtered = _.filter(this.asides.nutricionales, { categoria })
            _.forEach(filtered, (item) => {
                item.indexInNutritionals = _.findIndex(this.asides.nutricionales, item)
                indx.push(item)
            })
            return indx;
        }
    },
    watch: {
        'form.clave_clase_division'() {
            let cp = _.cloneDeep(this.form),
                filtering = { division_id: cp.clave_clase_division + '' };

            this.asides.claves.grupos_f = _.filter(this.asides.claves.grupos, filtering)

            if (!this.asides.claves.grupos_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_grupo = null
                this.$refs.automodal.set(cp)
            }
        },
        'form.clave_clase_grupo'() {
            let cp = _.cloneDeep(this.form),
                filtering = { grupo_id: cp.clave_clase_grupo + '' };
            this.asides.claves.clases_f = _.filter(this.asides.claves.clases, filtering)
            if (!this.asides.claves.clases_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_clase = null
                this.$refs.automodal.set(cp)
            }
        },
        'form.clave_clase_clase'() {
            let cp = _.cloneDeep(this.form),
                filtering = { clase_id: cp.clave_clase_clase + '' };
            this.asides.claves.claves_f = _.filter(this.asides.claves.claves, filtering)
            if (!this.asides.claves.claves_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_pk = null
                this.$refs.automodal.set(cp)
            }
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" :form-archetype="cArchetype" @refresh="refresh()"
        :handler="getHandler()" :size="(form.id)?'xl':'md'" @defined="checkAsides()" :allow-aside="!!form.id_pk"
        :allow-delete="!!form.id_pk" :form-id="form.id">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="9">
            <b-tabs pill>
                <b-tab title="Presentaciones">
                    <!-- <presentaciones-index /> -->
                    <PresentacionQuicktable tipo="1" :elemento-id="form.id_pk" :captions="captionsExceptBy(['titulo_extendido', 'categoria'])"/>
                </b-tab>
                <b-tab title="Nutricionales">
                    <b-alert show>
                        Recuerda capturar todos los ementos por cada <strong>100gr</strong>
                    </b-alert>
                    <b-card v-for="cat in nutricionalesCat" :key="cat" :header="cat" no-body>
                        <b-table-simple>

                            <b-thead>
                                <b-tr>
                                    <b-th>Elemento</b-th>
                                    <b-th>Cantidad</b-th>
                                    <b-th>Unidad</b-th>
                                </b-tr>
                            </b-thead>

                            <b-tbody>
                                <b-tr v-for="(item, $index) in getNutricionalsIndex(cat)" :key="$index">
                                    <b-td>
                                        <label class="m-0 p-0 positionate"
                                            :for="`nutri-${item.elementonutricional_id}`">{{ item.elementonutricional }}</label>
                                    </b-td>
                                    <b-td>
                                        <b-input :id="`nutri-${item.elementonutricional_id}`" @change="updateFormFromNutri"
                                            v-model="asides.nutricionales[item.indexInNutritionals].cantidad"
                                            type="number" />
                                    </b-td>
                                    <b-td>
                                        <b-input readonly :value="item.unidaddemediciontextual"></b-input>
                                    </b-td>
                                </b-tr>
                            </b-tbody>

                        </b-table-simple>
                    </b-card>
                </b-tab>
            </b-tabs>

        </b-col>
        <b-col slot="bottom" v-if="false">
            <pre>
                {{ nutricionalesCat }}
                {{ asides.nutricionales }}
            </pre>
        </b-col>
    </ui-edit-auto-modal>
</template>

<style scoped>.positionate {
    position: relative;
    bottom: 10px;
}</style>